import { BASE_URL, SOCIAL_LINKS } from "@/common/links";
import { Button } from "@/components/ui/Button";
import { DigitLogo } from "@/landing/components/DigitLogo";
import { OutboundCtaLink } from "@/landing/components/OutboundCtaLink";
import { signupCtaLabel } from "@/landing/lib/constants";

const footerLinkClass =
  "text-sm text-[var(--cli-text-secondary)] transition-colors duration-200 hover:text-[var(--cli-text)]";

export function WondatwinFooter() {
  return (
    <footer className="border-t border-[var(--cli-border)] bg-[#f0f0ec]">
      <div className="mx-auto grid max-w-5xl gap-10 px-6 py-12 md:grid-cols-[1.4fr_1fr] md:items-end md:py-16">
        <div>
          <a
            href="/"
            className="inline-flex items-center gap-3"
            aria-label="Wonda Twin home"
          >
            <DigitLogo className="w-28" variant="nav" light />
            <span className="border-l border-[var(--cli-border)] pl-3 font-mono text-sm font-medium tracking-[0.12em] text-[var(--cli-text-secondary)] uppercase">
              Twin
            </span>
          </a>
          <p className="mt-5 max-w-md text-sm leading-6 text-[var(--cli-text-secondary)]">
            A managed browser for responsible LinkedIn automation, built for AI
            agents and backed by Wonda.
          </p>
          <p className="mt-3 text-xs text-[var(--cli-text-muted)]">
            A product by Degaus Technologies LTD
          </p>
        </div>

        <div className="flex flex-col gap-6 md:items-end">
          <nav
            aria-label="Wonda Twin footer"
            className="flex flex-wrap gap-x-5 gap-y-3 md:justify-end"
          >
            <a href="#why-wonda" className={footerLinkClass}>
              Product
            </a>
            <a href="#use-cases" className={footerLinkClass}>
              Use cases
            </a>
            <a href="#pricing" className={footerLinkClass}>
              Pricing
            </a>
            <a href={`${BASE_URL}/docs`} className={footerLinkClass}>
              Docs
            </a>
          </nav>
          <Button asChild variant="steward" size="sm">
            <OutboundCtaLink placement="footer">
              {signupCtaLabel("Try Wonda Twin")}
            </OutboundCtaLink>
          </Button>
        </div>
      </div>

      <div className="border-t border-[var(--cli-border)] px-6 py-6">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 text-xs text-[var(--cli-text-muted)] sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <a
              href={`${BASE_URL}/terms`}
              className="hover:text-[var(--cli-text)]"
            >
              Terms
            </a>
            <a
              href={`${BASE_URL}/privacy`}
              className="hover:text-[var(--cli-text)]"
            >
              Privacy
            </a>
            <a
              href={`${BASE_URL}/acceptable-use`}
              className="hover:text-[var(--cli-text)]"
            >
              Acceptable use
            </a>
            <a
              href="mailto:contact@wonda.sh"
              className="hover:text-[var(--cli-text)]"
            >
              Contact
            </a>
          </div>
          <div className="flex gap-4">
            <a
              href={SOCIAL_LINKS.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[var(--cli-text)]"
            >
              LinkedIn
            </a>
            <a
              href={SOCIAL_LINKS.github}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[var(--cli-text)]"
            >
              GitHub
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
